import styled from "styled-components";

export const StyledLiveOrders = styled.div`
    .orders-holder {
        display: flex;
        align-items: flex-start;
        gap: 25px;
        position: relative;
        @media (min-width: 1400px) {
            gap: 40px;
        }
    }

    .infinite-scroll-text {
        display: block;
        text-align: center;
        font-size: 18px;
        line-height: 22px;
        font-weight: 500;
    }

    .img-holder {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .dish-holder {
        @media (min-width: 576px) {
            display: flex;
            align-items: center;
            gap: 7px;
        }

        .image-holder {
            width: 100%;
            max-width: 60px;
            background: var(--gray-150);
            border-radius: 5px;
            overflow: hidden;
            margin: 0 0 10px;

            @media (min-width: 576px) {
                margin: 0;
            }

            img {
                display: block;
                width: 100%;
                height: auto;
                object-fit: cover;
            }
        }

        .description {
            .heading {
                display: block;
                font-weight: 600;
                margin: 0 0 2px;
            }

            .category {
                display: block;
                margin: 0 0 2px;

                b {
                    font-weight: 500;
                }
            }

            .price-holder {
                color: ${({theme}) => theme?.light?.primary};

                .price {
                    font-size: 18px;
                    line-height: 22px;
                }
            }
        }
    }

    .user-name,
    .price {
        font-weight: 500;
        margin: 0 0 5px;
    }

    .sidebar-head,
    .dropdown {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .head-holder {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        gap: 10px;
        margin: 0 0 20px;

        @media (min-width: 768px) {
            gap: 20px;
        }
        @media (min-width: 1024px) {
            flex-direction: row;
            gap: 10px;
        }
        .col {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            gap: 10px;

            @media (min-width: 768px) {
                flex-direction: row;
                gap: 13px;
            }
            @media (min-width: 1024px) {
                justify-content: flex-start;
            }
            &.filters-col {
                justify-content: center;
                flex-wrap: nowrap;
                @media (min-width: 1024px) {
                    justify-content: flex-end;
                }
            }

        }
        .date {
            width: 100%;
            @media (min-width: 576px) {
                max-width: 180px;
            }

            input {
                padding: 0 10px;
            }
        }
        .holder-title {
            color: var(--text-color);
            font-size: 28px;
            line-height: 32px;
            font-weight: 600;
            margin: 0;
        }
        .sidebar-head {
            width: 100%;
            border-radius: 60px;
            border: 0.5px solid rgba(205, 205, 205, 1);

            @media (min-width: 576px) {
                max-width: 270px;
            }
            .react-select__control {
                height: 35px;
                background: var(--white);
                color: var(--text-color);
                border: none;
                font-size: 14px;
                line-height: 18px;
                padding-left: 40px;
                .react-select__placeholder {
                    color: var(--text-color);
                }
            }

            &.filter {
                @media (min-width: 576px) {
                    max-width: 130px;
                }

                .react-select__control {
                    padding-left: 10px;
                }
            }
        }
    }

    .sideBar {
        width: 100%;
        max-width: 275px;
        height: calc(100vh - 200px);
        overflow: auto;
        padding: 0 10px;
        margin: 0 -10px;
        transition: all 0.4s ease-in-out;

        @media (min-width: 1400px) {
            max-width: 350px;
        }
        @media (max-width: 1199px) {
            max-width: 320px;
            position: absolute;
            top: 10px;
            left: -100%;
            z-index: 1;
            background: var(--white);
        }
        .activeOrderSideBar & {
            left: 0;
        }

        .order {
            padding: 15px 10px;
            display: flex;
            justify-content: space-between;
            gap: 5px;
            border-radius: 7px;
            box-shadow: 0px 1px 11px 0px #0000001a;
            transition: all 0.3s;
            cursor: pointer;

            @media (min-width: 1400px) {
                padding: 18px 14px;
            }

            &:not(:last-child) {
                margin: 0 0 15px;
                @media (min-width: 1400px) {
                    margin: 0 0 20px;
                }
            }

            &:hover,
            &.active {
                color: var(--white);
                background: ${({theme}) => theme?.light?.primary};
                .order-type {
                    &:before {
                        background: var(--white);
                    }
                }
                .price,
                .order-id,
                .list-icon {
                    color: var(--white);
                }
            }

            span {
                display: block;
            }

            .about-user,
            .price-holder {
                display: flex;
                align-items: center;
                gap: 5px;
            }

            .accept,
            .reject,
            .detail {
                font-size: 16px;
                line-height: 20px;
                font-weight: 500;
                &:hover {
                    color: var(--white);
                    img {
                        filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(298deg) brightness(200%) contrast(102%);
                    }
                }
            }

            .accept {
                color: var(--success);
            }
            .reject {
                color: var(--danger);
            }

            .list-icon {
                color: #777;
            }

            .img-holder {
                flex-shrink: 0;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                overflow: hidden;
                @media (min-width: 1200px) {
                    width: 35px;
                    height: 35px;
                }
                @media (min-width: 1400px) {
                    width: 40px;
                    height: 40px;
                }

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .user-name {
                max-width: 135px;
                overflow: hidden;
                text-overflow: ellipsis;
                @media (min-width: 1200px) {
                    max-width: 100px;
                }
                @media (min-width: 1400px) {
                    max-width: 150px;
                }
            }
            .user-name,
            .price {
                font-weight: 500;
                margin: 0 0 5px;
            }

            .order-type {
                font-size: 14px;
                line-height: 18px;
                font-weight: 300;
                position: relative;
                padding: 0 0 0 13px;

                &:before {
                    content: "";
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    left: 0;
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    background: ${({theme}) => theme?.light?.primary};
                }
            }

            .price {
                color: ${({theme}) => theme?.light?.primary};
            }

            .order-id {
                font-size: 14px;
                line-height: 18px;
                color: var(--light-gray);
            }
        }
    }

    .order-Summary {
        width: 100%;
        padding: 15px;
        border-radius: 20px;
        box-shadow: 0px 1px 16px 0px #00000014;
        @media (min-width: 992px) {
            padding: 20px;
        }

        .summary {
            @media (min-width: 992px) {
                height: calc(100vh - 310px);
                overflow-y: auto;
                padding-right: 5px;
            }
        }

        .head {
            display: flex;
            justify-content: space-between;
            padding: 0 20px 15px;
            border-bottom: 1px solid var(--gray-50);
            margin: 0 -20px 20px;
            @media (min-width: 992px) {
                margin: 0 -20px 30px;
            }

            .heading {
                display: block;
                font-size: 18px;
                line-height: 22px;
                color: ${({theme}) => theme?.light?.primary};
                position: relative;

                &:after {
                    content: "";
                    position: absolute;
                    bottom: -17px;
                    left: 0;
                    right: 0;
                    height: 3px;
                    background: ${({theme}) => theme?.light?.primary};
                    border-radius: 10px;
                }
            }

            .edit-icon {
                cursor: pointer;
            }
        }

        .order-description {
            margin: 0 0 20px;

            @media (min-width: 768px) {
                display: flex;
                gap: 30px;
            }
            @media (min-width: 1400px) {
                gap: 50px;
            }

            span {
                display: block;
            }
            .content-holder {
                margin: 0 0 20px;
                @media (min-width: 992px) {
                    width: 70%;
                    margin: 0;
                }
                @media (min-width: 768px) {
                    margin: 0 0 30px;
                }
                .content {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 5px;

                    .title {
                        font-size: 22px;
                        line-height: 36px;
                        font-weight: 500;

                        @media (min-width: 768px) {
                            font-size: 26px;
                            line-height: 30px;
                        }
                    }
                }
                .orderId {
                    margin: 0 0 15px;
                    color: var(--light-gray);

                    @media (min-width: 992px) {
                        margin: 0 0 30px;
                    }
                }

                .btn-holder,
                .tags-holder {
                    display: flex;
                    gap: 10px;
                }

                .tags-holder {
                    margin: 0 0 15px;
                    @media (min-width: 992px) {
                        margin: 0 0 30px;
                    }

                    .new,
                    .cash {
                        padding: 5px 10px;
                        border-radius: 60px;
                        color: var(--white);
                        background: ${({theme}) => theme?.light?.primary};
                    }

                    .new {
                        display: flex;
                        align-items: center;
                        gap: 5px;

                        &:before {
                            content: "";
                            width: 8px;
                            height: 8px;
                            border-radius: 50%;
                            background: var(--white);
                        }
                    }
                    .cash {
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        background: var(--text-color);
                    }
                }

                .col-holder {
                    @media (min-width: 576px) {
                        display: flex;
                        gap: 40px;
                    }

                    .col {
                        display: flex;
                        align-items: center;
                        gap: 10px;

                        @media (max-width: 575px) {
                            &:not(:last-child) {
                                margin: 0 0 15px;
                            }
                        }

                        .icon-holder {
                            width: 30px;
                            height: 30px;
                            display: flex;
                            flex-shrink: 0;
                            align-items: center;
                            justify-content: center;
                            background: var(--gray-50);
                            border-radius: 5px;
                        }

                        .title {
                            color: var(--gray);
                        }

                        .text {
                            font-size: 14px;
                            line-height: 18px;
                            font-weight: 300;
                        }
                    }
                }
            }

            .billing {
                padding: 12px 15px;
                border: 1px solid var(--gray-50);
                border-radius: 12px;
                @media (min-width: 992px) {
                    width: 30%;
                }

                .heading {
                    font-size: 18px;
                    line-height: 22px;
                    font-weight: 300;
                    margin: 0 0 12px;
                }

                .img-holder {
                    margin: 0 0 10px;
                }

                .address {
                    font-weight: 300;
                }
            }
        }
        .table-holder {
            background: ${({theme}) => theme?.light?.primary50};
            padding: 0 15px 20px;
            border-radius: 20px;
            overflow: hidden;
            @media (min-width: 992px) {
                padding: 10px 20px 20px;
            }

            .table {
                padding: 0 5px 15px 0;
                border-bottom: 1px solid var(--gray-150);
                margin: 0 0 15px;
            }

            .total {
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 20px;
                line-height: 24px;
                font-weight: 500;
                color: var(--text-color);
                margin: 0 0 20px;
            }
            .btn-holder {
                display: flex;
                justify-content: center;
            }
        }
    }
    .empty-summary {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        max-width: 200px;
        padding: 15px 10px 13px;
        margin: 15px auto;
        border-radius: 5px;
        color: var(--danger);
        background: #ffebeb;
        text-transform: capitalize;
        font-weight: 400;
    }

    .nav-opener {
        width: 35px;
        height: 35px;
        border-radius: 3px;
        background: var(--white);
        border: 1px solid ${({theme}) => theme?.light?.primary};
        border-radius: 5px;
        flex-shrink: 0;
        position: relative;

        @media (min-width: 1200px) {
            display: none;
        }

        &:before,
        &:after,
        span {
            background: ${({theme}) => theme?.light?.primary};
            border-radius: 4px;
            position: absolute;
            top: 50%;
            left: 25%;
            right: 25%;
            height: 4px;
            margin-top: -2px;
            transition: all 0.2s linear;
        }

        &:before,
        &:after {
            content: "";
            top: 30%;
        }

        &:after {
            top: 70%;
        }

        .activeOrderSideBar & {
            span {
                opacity: 0;
            }

            &:after,
            &:before {
                transform: rotate(45deg);
                top: 50%;
                left: 15%;
                right: 15%;
            }

            &:after {
                transform: rotate(-45deg);
            }

            &:hover {
                opacity: 0.9;
            }
        }
    }

    .orders-wrap {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
        gap: 20px;
        margin-bottom: 20px;
    }

    .tabs-wrap {
        display: flex;
        flex-direction: row;
        gap: 6px;
        padding: 5px;
        border-radius: 40px;
        background: rgba(246, 246, 246, 1);
        margin-bottom: 30px;
        overflow-x: auto;
        width: 100%;
        
        &::-webkit-scrollbar {
            display: none;
        }

        .btn {
            gap: 8px;
            width: 100%;
            flex: 1;
            border-radius: 40px;
            box-shadow: none;
            padding: 8px 16px;
            font-size: 14px;
            line-height: 18px;
            font-weight: 500;
            color: rgba(143, 143, 143, 1);
            background: transparent;
            white-space: nowrap;

            &:hover {
                color: var(--text-color);
            }

            .count {
                color: rgba(143, 143, 143, 1);
                font-size: 12px;
                line-height: 16px;
                font-weight: 500;
                padding: 2px 8px;
                background: rgba(230, 230, 230, 1);
                transition: all 0.3s ease-in-out;
                border-radius: 40px;
            }
            &.active-btn {
                background: var(--white);
                color: var(--text-color);
                box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.05);

                .count {
                    background: rgba(245, 126, 42, 0.15);
                    color: var(--primary);
                }
            }
            .dot {
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background-color: transparent;
                &.new-dot {
                    background-color: rgba(245, 126, 42, 1);
                }
                &.preparing-dot {
                    background-color: rgba(44, 185, 255, 1);
                }
                &.ready-dot {
                    background-color: rgba(39, 196, 83, 1);
                }
            }
        }
    }

            }
        }
    }
`;

export const NewOrderOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99999;
    background: rgba(22, 163, 74, 0.92);
    backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    animation: overlayFadeIn 0.3s ease-out;

    @keyframes overlayFadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }

    @keyframes pulseRing {
        0% { transform: translate(-50%, -50%) scale(0.8); opacity: 0.6; }
        50% { transform: translate(-50%, -50%) scale(1.3); opacity: 0; }
        100% { transform: translate(-50%, -50%) scale(0.8); opacity: 0.6; }
    }

    @keyframes countBounce {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.08); }
    }

    .overlay-content {
        text-align: center;
        color: #fff;
        position: relative;
        user-select: none;
    }

    .pulse-ring {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 220px;
        height: 220px;
        border-radius: 50%;
        border: 3px solid rgba(255, 255, 255, 0.4);
        animation: pulseRing 2s ease-in-out infinite;
        pointer-events: none;
    }

    .order-count {
        font-size: 120px;
        font-weight: 800;
        line-height: 1;
        text-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
        animation: countBounce 2s ease-in-out infinite;
        margin-bottom: 10px;
    }

    .overlay-title {
        font-size: 36px;
        font-weight: 700;
        margin: 0 0 8px;
        text-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
    }

    .overlay-subtitle {
        font-size: 16px;
        font-weight: 400;
        opacity: 0.85;
        margin: 0;
    }
`;

export const NewOrderBanner = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99998;
    background: linear-gradient(135deg, #16a34a, #22c55e);
    color: #fff;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 24px;
    cursor: pointer;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    animation: bannerSlideDown 0.35s ease-out;

    @keyframes bannerSlideDown {
        from { transform: translateY(-100%); }
        to { transform: translateY(0); }
    }

    @keyframes bannerPulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.5; }
    }

    .banner-pulse {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #fff;
        animation: bannerPulse 1.5s ease-in-out infinite;
        flex-shrink: 0;
    }

    .banner-count {
        font-size: 22px;
        font-weight: 800;
        flex-shrink: 0;
    }

    .banner-text {
        font-size: 15px;
        font-weight: 500;
        flex: 1;
    }

    .banner-close {
        background: rgba(255, 255, 255, 0.2);
        border: none;
        color: #fff;
        font-size: 18px;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        transition: background 0.2s;

        &:hover {
            background: rgba(255, 255, 255, 0.35);
        }
    }
`;
